export const DEFAULT_DATE_FORMAT = "DD MMM YYYY";
export const DEFAULT_DATE_FORMAT_WITH_COMMA = "DD MMM, YYYY";
export const DATE_AND_TIME_FORMAT = "DD MMM, YYYY HH:mm";
export const DATE_FORMAT_FOR_DATEPICKER = "YYYY-MM-DDTHH:mm";
export const ISO_FORMAT_FOR_BACKEND = "YYYY-MM-DDTHH:mmZ";

export const MOMENT_HOUR = "hour";
export const MOMENT_MINUTE = "minute";
export const MOMENT_YEAR = 'year';